import React from "react";
import { FiMail, FiPhone, FiMapPin, FiCalendar, FiHash, FiCheckCircle, FiClock, FiAlertCircle } from "react-icons/fi";

/* ─────────────────────────────────────────────
   INLINE CSS — no external file needed
───────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

.inv1__wrap * { box-sizing: border-box; margin: 0; padding: 0; }

.inv1__wrap {
  font-family: 'DM Sans', sans-serif;
  background: #dde8e8;
  min-height: 100vh;
 
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* ── paper — exact A4 ── */
.inv1__paper {
  background: #ffffff;
  width: 210mm;
  min-height: 297mm;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(10,85,86,0.18), 0 2px 8px rgba(10,85,86,0.10);
  position: relative;
  flex-shrink: 0;
}

/* ── top accent bar ── */
.inv1__accent-bar {
  height: 5px;
  background: linear-gradient(90deg, #0a5556 0%, #14b8a6 55%, #FFD166 100%);
}

/* ══════════════════════════════════════
   HEADER
══════════════════════════════════════ */
.inv1__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  padding: 36px 40px 28px;
  background: #ffffff;
  border-bottom: 1px solid rgba(10,85,86,0.08);
  flex-wrap: wrap;
}

/* seller brand block */
.inv1__brand-icon {
  width: 52px; height: 52px; border-radius: 16px;
  background: linear-gradient(135deg, #0a5556, #14b8a6);
  display: flex; align-items: center; justify-content: center;
  font-family: 'Sora', sans-serif; font-size: 22px; font-weight: 800;
  color: #fff; margin-bottom: 12px;
  box-shadow: 0 6px 18px rgba(10,85,86,0.28);
  flex-shrink: 0;
}
.inv1__seller-name {
  font-family: 'Sora', sans-serif; font-size: 22px; font-weight: 800;
  color: #0a5556; letter-spacing: -0.03em; margin-bottom: 10px;
}
.inv1__seller-meta { display: flex; flex-direction: column; gap: 5px; }
.inv1__seller-row {
  display: flex; align-items: center; gap: 7px;
  font-size: 12.5px; color: #5a8080;
}
.inv1__seller-row svg { flex-shrink: 0; color: #14b8a6; }
.inv1__gstin-chip {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 11px; border-radius: 8px; margin-top: 4px;
  background: rgba(10,85,86,0.07); border: 1px solid rgba(10,85,86,0.16);
  font-family: 'Sora', sans-serif; font-size: 11px; font-weight: 700;
  color: #0a5556; letter-spacing: 0.04em;
}

/* invoice meta block */
.inv1__meta { text-align: right; }
.inv1__invoice-label {
  font-family: 'Sora', sans-serif; font-size: 32px; font-weight: 800;
  color: #0a5556; letter-spacing: 0.1em; margin-bottom: 16px;
  text-transform: uppercase;
}
.inv1__meta-grid {
  display: grid; grid-template-columns: auto auto;
  gap: 7px 18px; justify-content: end;
}
.inv1__meta-lbl { font-size: 11px; font-family: 'Sora', sans-serif; font-weight: 600; color: #9ababa; text-transform: uppercase; letter-spacing: 0.07em; text-align: right; }
.inv1__meta-val { font-size: 13px; font-weight: 700; color: #0f2a2a; font-family: 'Sora', sans-serif; text-align: right; }

/* status badge */
.inv1__status {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 12px; border-radius: 50px;
  font-size: 11px; font-family: 'Sora', sans-serif; font-weight: 700;
}
.inv1__status--paid    { background: rgba(16,185,129,0.12); color: #065f46; border: 1px solid rgba(16,185,129,0.28); }
.inv1__status--unpaid  { background: rgba(239,68,68,0.10); color: #991b1b; border: 1px solid rgba(239,68,68,0.26); }
.inv1__status--partial { background: rgba(245,158,11,0.12); color: #92400e; border: 1px solid rgba(245,158,11,0.30); }
.inv1__status--pending { background: rgba(59,130,246,0.10); color: #1d4ed8; border: 1px solid rgba(59,130,246,0.24); }
.inv1__status-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }

/* ══════════════════════════════════════
   BILLING SECTION
══════════════════════════════════════ */
.inv1__billing {
  padding: 24px 40px;
  background: rgba(10,85,86,0.025);
  border-bottom: 1px solid rgba(10,85,86,0.08);
}
.inv1__billing-lbl {
  font-size: 10px; font-family: 'Sora', sans-serif; font-weight: 700;
  letter-spacing: 0.1em; text-transform: uppercase; color: #9ababa; margin-bottom: 12px;
}
.inv1__bill-card {
  background: #fff; border: 1px solid rgba(10,85,86,0.10); border-radius: 14px;
  padding: 18px 20px; display: inline-flex; flex-direction: column; gap: 7px;
  min-width: 260px; box-shadow: 0 2px 10px rgba(10,85,86,0.05);
}
.inv1__bill-name {
  font-family: 'Sora', sans-serif; font-size: 16px; font-weight: 800; color: #0f2a2a; margin-bottom: 2px;
}
.inv1__bill-row {
  display: flex; align-items: center; gap: 7px;
  font-size: 12.5px; color: #5a8080;
}
.inv1__bill-row svg { color: #14b8a6; flex-shrink: 0; }
.inv1__bill-address { font-size: 12.5px; color: #5a8080; line-height: 1.5; }

/* ══════════════════════════════════════
   ITEMS TABLE
══════════════════════════════════════ */
.inv1__table-section { padding: 28px 40px; }
.inv1__table-title {
  font-family: 'Sora', sans-serif; font-size: 11px; font-weight: 700;
  letter-spacing: 0.09em; text-transform: uppercase; color: #9ababa; margin-bottom: 14px;
}
.inv1__table {
  width: 100%; border-collapse: collapse; border-radius: 14px; overflow: hidden;
  border: 1px solid rgba(10,85,86,0.09);
}
.inv1__table thead tr {
  background: linear-gradient(90deg, rgba(10,85,86,0.07), rgba(20,184,166,0.04));
}
.inv1__table thead th {
  font-family: 'Sora', sans-serif; font-size: 10.5px; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase; color: #0a5556;
  padding: 13px 16px; white-space: nowrap; border-bottom: 1px solid rgba(10,85,86,0.09);
}
.inv1__table thead th:first-child { padding-left: 20px; border-radius: 0; }
.inv1__table thead th:last-child  { padding-right: 20px; text-align: right; }
.inv1__table thead th.th-right    { text-align: right; }

.inv1__table tbody tr { border-bottom: 1px solid rgba(10,85,86,0.06); transition: background 0.12s; }
.inv1__table tbody tr:last-child { border-bottom: none; }
.inv1__table tbody tr:hover { background: rgba(10,85,86,0.025); }
.inv1__table tbody td { padding: 13px 16px; font-size: 13px; color: #0f2a2a; vertical-align: middle; }
.inv1__table tbody td:first-child { padding-left: 20px; }
.inv1__table tbody td:last-child  { padding-right: 20px; text-align: right; }
.inv1__table tbody td.td-right    { text-align: right; }

.inv1__row-num {
  display: inline-flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; border-radius: 8px;
  background: rgba(10,85,86,0.09); color: #0a5556;
  font-family: 'Sora', sans-serif; font-size: 11px; font-weight: 800;
}
.inv1__desc-name { font-weight: 700; color: #0f2a2a; font-size: 13px; }
.inv1__hsn-chip {
  display: inline-block; padding: 2px 8px; border-radius: 6px;
  background: rgba(10,85,86,0.06); color: #5a8080;
  font-family: 'Sora', sans-serif; font-size: 10.5px; font-weight: 700; letter-spacing: 0.04em;
}
.inv1__tax-chip {
  display: inline-block; padding: 2px 9px; border-radius: 6px;
  background: rgba(20,184,166,0.10); color: #0c7172;
  font-family: 'Sora', sans-serif; font-size: 11px; font-weight: 700;
}
.inv1__amount { font-family: 'Sora', sans-serif; font-size: 13.5px; font-weight: 800; color: #0a5556; }

/* ══════════════════════════════════════
   FOOTER (notes + summary)
══════════════════════════════════════ */
.inv1__footer {
  display: flex; align-items: flex-start; gap: 24px;
  padding: 0 40px 36px;
  flex-wrap: wrap;
}
.inv1__notes {
  flex: 1; min-width: 220px;
  background: rgba(10,85,86,0.03); border: 1px solid rgba(10,85,86,0.09);
  border-radius: 14px; padding: 18px 20px;
}
.inv1__notes-lbl {
  font-family: 'Sora', sans-serif; font-size: 10px; font-weight: 700;
  letter-spacing: 0.09em; text-transform: uppercase; color: #9ababa; margin-bottom: 8px;
}
.inv1__notes-text { font-size: 13px; color: #5a8080; line-height: 1.6; }

/* summary box */
.inv1__summary {
  min-width: 260px; width: 300px;
  background: #ffffff; border: 1px solid rgba(10,85,86,0.10);
  border-radius: 16px; overflow: hidden;
  box-shadow: 0 4px 16px rgba(10,85,86,0.07);
}
.inv1__summary-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 11px 18px; border-bottom: 1px solid rgba(10,85,86,0.06);
  font-size: 13px;
}
.inv1__summary-row:last-child { border-bottom: none; }
.inv1__summary-lbl { color: #5a8080; font-weight: 500; }
.inv1__summary-val { font-family: 'Sora', sans-serif; font-weight: 700; color: #0f2a2a; }

.inv1__grand-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 18px;
  background: linear-gradient(135deg, #0a5556, #0c7172);
}
.inv1__grand-lbl {
  font-family: 'Sora', sans-serif; font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.75);
  text-transform: uppercase; letter-spacing: 0.07em;
}
.inv1__grand-val {
  font-family: 'Sora', sans-serif; font-size: 20px; font-weight: 800; color: #ffffff;
}

/* ── bottom strip ── */
.inv1__bottom-strip {
  height: 4px;
  background: linear-gradient(90deg, #FFD166 0%, #14b8a6 50%, #0a5556 100%);
}

/* ── print ── */
@page { size: A4 portrait; margin: 0; }
@media print {
  .inv1__wrap { background: none !important; padding: 0 !important; display: block !important; }
  .inv1__paper {
    width: 210mm !important; min-height: 297mm !important;
    box-shadow: none !important; margin: 0 !important;
  }
}

@media (max-width: 600px) {
  .inv1__header { padding: 24px 20px 20px; }
  .inv1__billing, .inv1__table-section { padding-left: 20px; padding-right: 20px; }
  .inv1__footer { padding: 0 20px 28px; flex-direction: column; }
  .inv1__summary { width: 100%; }
  .inv1__invoice-label { font-size: 24px; }
  .inv1__meta-grid { gap: 6px 12px; }
}
`;

/* ─── helpers ─── */
const getStatusInfo = (status = "") => {
  const s = status.toLowerCase();
  if (s === "paid")    return { cls: "inv1__status--paid",    dot: "#10b981", icon: <FiCheckCircle size={12} /> };
  if (s === "unpaid")  return { cls: "inv1__status--unpaid",  dot: "#ef4444", icon: <FiAlertCircle size={12} /> };
  if (s === "partial") return { cls: "inv1__status--partial", dot: "#f59e0b", icon: <FiClock size={12} /> };
  return                      { cls: "inv1__status--pending", dot: "#3b82f6", icon: <FiClock size={12} /> };
};

const fmt  = (n) => `₹${Number(n || 0).toFixed(2)}`;
const init = (name = "") => name.trim()[0]?.toUpperCase() || "?";

/* ═══════════════════════════════════════════════════
   COMPONENT — ALL DATA LOGIC COMPLETELY UNCHANGED
═══════════════════════════════════════════════════ */
const InvoiceOne = ({ invoiceData }) => {
  console.log("invoiceData", invoiceData);

  /* ── DEFAULT FALLBACK DATA (UNCHANGED) ── */
  const defaultData = {
    id: "6",
    items: [
      { hsn: "1234", qty: 1, tax: 18, rate: 500,  description: "Product/Service A" },
      { hsn: "5678", qty: 1, tax: 12, rate: 1000, description: "Product/Service B" },
    ],
    notes: "Please make the payment within 15 days.",
    seller: {
      name: "Your Company Name",
      gstin: "27AABCA5678A1Z5",
      phone: "9000000000",
      state: "Maharashtra",
    },
    dueDate: "2026-01-02",
    customer: {
      name: "Acme Corp",
      email: "contact@acme.com",
      gstin: "27AABCA1234A1Z5",
      phone: "9876543210",
      state: "Maharashtra",
      address: "123 Main St, Maharashtra",
    },
    invoiceDate: "2025-12-18",
    invoiceNumber: "INV-002",
    paymentStatus: "Paid",
    itemSubtotal: 1500,
    taxableAmount: 1500,
    gstBreakdown: {
      CGST: 105,
      SGST: 105,
      isInterState: false,
    },
    grandTotal: 1710,
  };

  /* ── FINAL DATA RESOLVER (UNCHANGED) ── */
  const data = invoiceData?.invoice_data
    ? {
        ...invoiceData.invoice_data,
        invoiceNumber: invoiceData.invoice_number,
        grandTotal: Number(invoiceData.grand_total),
      }
    : defaultData;

  const statusInfo = getStatusInfo(data.paymentStatus);

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <div className="inv1__wrap">
        <div className="inv1__paper">

          {/* top gradient bar */}
          <div className="inv1__accent-bar" />

          {/* ── HEADER ── */}
          <header className="inv1__header">

            {/* Seller / Brand */}
            <div>
              <div className="inv1__brand-icon">{init(data.seller?.name)}</div>
              <div className="inv1__seller-name">{data.seller?.name}</div>
              <div className="inv1__seller-meta">
                <div className="inv1__seller-row">
                  <FiMapPin size={12} /> {data.seller?.state}, India
                </div>
                <div className="inv1__seller-row">
                  <FiPhone size={12} /> {data.seller?.phone}
                </div>
                <div className="inv1__gstin-chip">
                  GSTIN: {data.seller?.gstin}
                </div>
              </div>
            </div>

            {/* Invoice Meta */}
            <div className="inv1__meta">
              <div className="inv1__invoice-label">Invoice</div>
              <div className="inv1__meta-grid">
                <div className="inv1__meta-lbl">Invoice #</div>
                <div className="inv1__meta-val">{data.invoiceNumber}</div>

                <div className="inv1__meta-lbl">Date</div>
                <div className="inv1__meta-val">{data.invoiceDate}</div>

                <div className="inv1__meta-lbl">Due Date</div>
                <div className="inv1__meta-val">{data.dueDate}</div>

                <div className="inv1__meta-lbl">Status</div>
                <div className="inv1__meta-val">
                  <span className={`inv1__status ${statusInfo.cls}`}>
                    <span className="inv1__status-dot" style={{ background: statusInfo.dot }} />
                    {data.paymentStatus}
                  </span>
                </div>
              </div>
            </div>

          </header>

          {/* ── BILL TO ── */}
          <section className="inv1__billing">
            <div className="inv1__billing-lbl">Bill To</div>
            <div className="inv1__bill-card">
              <div className="inv1__bill-name">{data.customer?.name}</div>
              {data.customer?.address && (
                <div className="inv1__bill-address">{data.customer?.address}</div>
              )}
              {data.customer?.email && (
                <div className="inv1__bill-row"><FiMail size={12} /> {data.customer?.email}</div>
              )}
              {data.customer?.phone && (
                <div className="inv1__bill-row"><FiPhone size={12} /> {data.customer?.phone}</div>
              )}
              {data.customer?.gstin && (
                <div className="inv1__gstin-chip" style={{ marginTop: 4 }}>
                  GSTIN: {data.customer?.gstin}
                </div>
              )}
            </div>
          </section>

          {/* ── ITEMS TABLE ── */}
          <div className="inv1__table-section">
            <div className="inv1__table-title">Line Items</div>
            <table className="inv1__table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>HSN</th>
                  <th className="th-right">Qty</th>
                  <th className="th-right">Rate</th>
                  <th className="th-right">Tax %</th>
                  <th className="th-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                {data.items?.map((item, i) => (
                  <tr key={i}>
                    <td><span className="inv1__row-num">{i + 1}</span></td>
                    <td><span className="inv1__desc-name">{item.description}</span></td>
                    <td><span className="inv1__hsn-chip">{item.hsn}</span></td>
                    <td className="td-right" style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700 }}>{item.qty}</td>
                    <td className="td-right" style={{ fontFamily: "'Sora',sans-serif", fontWeight: 600 }}>₹{Number(item.rate).toFixed(2)}</td>
                    <td className="td-right"><span className="inv1__tax-chip">{item.tax}%</span></td>
                    <td className="td-right">
                      <span className="inv1__amount">₹{(item.qty * item.rate).toFixed(2)}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ── FOOTER: notes + summary ── */}
          <footer className="inv1__footer">

            {/* Notes */}
            <div className="inv1__notes">
              <div className="inv1__notes-lbl">Notes / Remarks</div>
              <div className="inv1__notes-text">{data.notes}</div>
            </div>

            {/* Summary */}
            <div className="inv1__summary">
              <div className="inv1__summary-row">
                <span className="inv1__summary-lbl">Subtotal</span>
                <span className="inv1__summary-val">{fmt(data.itemSubtotal)}</span>
              </div>
              <div className="inv1__summary-row">
                <span className="inv1__summary-lbl">Taxable Amount</span>
                <span className="inv1__summary-val">{fmt(data.taxableAmount)}</span>
              </div>

              {/* GST breakdown — UNCHANGED condition */}
              {!data.gstBreakdown?.isInterState && (
                <>
                  <div className="inv1__summary-row">
                    <span className="inv1__summary-lbl">CGST</span>
                    <span className="inv1__summary-val">{fmt(data.gstBreakdown?.CGST)}</span>
                  </div>
                  <div className="inv1__summary-row">
                    <span className="inv1__summary-lbl">SGST</span>
                    <span className="inv1__summary-val">{fmt(data.gstBreakdown?.SGST)}</span>
                  </div>
                </>
              )}

              <div className="inv1__grand-row">
                <span className="inv1__grand-lbl">Total</span>
                <span className="inv1__grand-val">{fmt(data.grandTotal)}</span>
              </div>
            </div>

          </footer>

          {/* bottom gradient strip */}
          <div className="inv1__bottom-strip" />

        </div>
      </div>
    </>
  );
};

export default InvoiceOne;
